import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[ngxAcceptNumberOnly]',
  standalone: false,
})
export class AcceptNumberOnlyDirective {
  constructor() {}
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const invalidChars = ['e', 'E', '+', '-', '.'];

    // Allow navigation keys like Backspace, Tab, Arrow keys, etc.
    if (['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(event.key)) {
      return;
    }

    // Prevent invalid characters
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }
}
